import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles(({ spacing, breakpoints }) => ({
  inputIcon: {
    fontSize: '1.2rem',
    color: '#6c687d',
    textAlign: 'center',
  },
  textField: {
    margin: '10px 0 25px 0',
    width: '60%',
  },
  [breakpoints.down('xs')]: {
    textField: {
      width: '100%',
    },
  },
}));

export default useStyle;
